import { render, staticRenderFns } from "./menu_aside.vue?vue&type=template&id=42a6b234&scoped=true&"
import script from "./menu_aside.vue?vue&type=script&lang=js&"
export * from "./menu_aside.vue?vue&type=script&lang=js&"
import style0 from "./menu_aside.vue?vue&type=style&index=0&id=42a6b234&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6b234",
  null
  
)

export default component.exports